var map = {
	"./min_img_s1.jpg": 6026,
	"./min_img_s2.jpg": 3774,
	"./min_img_s3.jpg": 4361,
	"./min_img_s4.jpg": 2252,
	"./min_img_s5.jpg": 6478,
	"./min_img_s6.jpg": 1410,
	"./min_img_s7.jpg": 5774,
	"./min_img_s8.jpg": 3037,
	"./min_img_s9.jpg": 9694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3308;